export const env = process.env.REACT_APP_ENVIRONMENT || "gb";

export const ORDERS_PERIOD_MS = 3 * 3600 * 1000;

export const isLegacyEnv =
  ["production", "development"].indexOf(
    process.env.REACT_APP_ENVIRONMENT || "development",
  ) !== -1;
